import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/hooks/useAppStore';
import { track } from '@/utils/tracker';

export default function HeroBanner() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useAppStore();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative w-full px-4 pt-2">
      {/* 深色背景大卡片 Banner */}
      <div
        className="relative w-full overflow-hidden"
        style={{
          borderRadius: '20px',
          minHeight: '180px',
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0) scale(1)' : 'translateY(12px) scale(0.98)',
          transition: 'all 0.7s cubic-bezier(0.22, 1, 0.36, 1)',
        }}
      >
        {/* 背景图 */}
        <img
          src="https://static.readdy.ai/image/feef753f1ed8344cc3f9a51076258ebd/085862089bb321563a5b1cdcc3a9b49b.png"
          alt="AI"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />

        {/* 暗色渐变遮罩 */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(90deg, rgba(20,10,40,0.85) 0%, rgba(20,10,40,0.5) 50%, rgba(20,10,40,0.2) 100%)',
          }}
        />

        <div className="relative flex items-center p-5">
          {/* 左侧文字 */}
          <div className="flex-1 min-w-0">
            <h1 className="text-xl font-bold text-white leading-tight tracking-tight mb-1.5">
              {t('home_heroTitle')}
            </h1>
            <p className="text-xs text-white/60 mb-4">
              {t('home_heroSubtitle')}
            </p>
            <button
              onClick={() => {
                track.homeCtaClick('hero_banner');
                track.homeEntryClick({
                  entry_id: 'hero_banner',
                  entry_name: t('home_heroTitle'),
                  source: 'home_banner',
                });
                navigate(user ? '/generate' : '/login?redirect=/generate');
              }}
              className="inline-flex items-center gap-1 px-4 py-2 rounded-full text-white text-xs font-medium cursor-pointer active:scale-95 transition-transform whitespace-nowrap"
              style={{
                background: 'rgba(255,255,255,0.15)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.2)',
              }}
            >
              {t('gen_generate')}
              <i className="ri-arrow-right-line text-xs" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
